import { storage } from '@/utils'
import _ from 'lodash'

let authorization = ''
let localAuthorization = storage.getLocalData('AB_AUTHORIZATION')
// console.log('当前token：' + localAuthorization)
try {
  if (!_.isEmpty(localAuthorization)) {
    authorization = localAuthorization
  }
} catch (e) {}

let nickname = ''
let localNickname = storage.getLocalData('AB_NICKNAME')
// console.log('当前nickname：' + localNickname)
try {
  if (!_.isEmpty(localNickname)) {
    nickname = localNickname
  }
} catch (e) {}

let mobile = ''
let localMobile = storage.getLocalData('AB_MOBILE')
// console.log('当前mobile：' + localMobile)
try {
  if (!_.isEmpty(localMobile)) {
    mobile = localMobile
  }
} catch (e) {}

let openid = ''
let localOpenid = storage.getLocalData('AB_OPENID')
// console.log('当前openid：' + localOpenid)
try {
  if (!_.isEmpty(localOpenid)) {
    openid = localOpenid
  }
} catch (e) {}

let currentCity = {}
let localCurrentCity = storage.getLocalData('AB_CURRENTCITY')
// console.log('当前保存的城市：' + localCurrentCity)
try {
  if (!_.isEmpty(localCurrentCity)) {
    currentCity = JSON.parse(localCurrentCity)
  }
} catch (e) {}

let citiesList = []
let cities = []

let projectCreate = {}
let localProjectCreate = storage.getLocalData('AB_PROJECTCREATE')
// console.log('projectCreate:' + localProjectCreate)
try {
  if (!_.isEmpty(localProjectCreate)) {
    projectCreate = JSON.parse(localProjectCreate)
  }
} catch (e) {}

let rebuildCreate = {}
let localRebuildCreate = storage.getLocalData('AB_REBUILDCREATE')
// console.log('rebuildCreate:' + localRebuildCreate)
try {
  if (!_.isEmpty(localRebuildCreate)) {
    rebuildCreate = JSON.parse(localRebuildCreate)
  }
} catch (e) {}

let showLoading = false
let showVoteSuccess = false

//新增
let fundingNewProjectCreate = {}
let localFundingNewProjectCreate = storage.getLocalData('AB_FUNDINGNEW_PROJECTCREATE')
try {
  if (!_.isEmpty(localFundingNewProjectCreate)) {
    fundingNewProjectCreate = JSON.parse(localFundingNewProjectCreate)
  }
} catch (e) {}

export default {
  authorization,
  nickname,
  mobile,
  openid,
  currentCity,
  citiesList,
  cities,
  projectCreate,
  rebuildCreate,
  showLoading,
  showVoteSuccess,
  fundingNewProjectCreate,
  profileVisitCount: storage.getLocalData('AB_PROFILEVISITCOUNT') || 0,
  channel: storage.getLocalData('AB_CHANNEL') || '',
  campaign: storage.getLocalData('AB_CAMPAIGN') || '',
  access_id: storage.getLocalData('AB_ACCESSID') || '',
  activity_id: storage.getLocalData('AB_ACTIVITYID') || '',
}



// WEBPACK FOOTER //
// ./src/store/state.js